import { render, staticRenderFns } from "./dataStatisticsBase.vue?vue&type=template&id=9d554ab6&scoped=true&"
import script from "./dataStatisticsBase.vue?vue&type=script&lang=js&"
export * from "./dataStatisticsBase.vue?vue&type=script&lang=js&"
import style0 from "./dataStatisticsBase.vue?vue&type=style&index=0&id=9d554ab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d554ab6",
  null
  
)

export default component.exports